module.exports = __webpack_public_path__ + "static/media/arrow-black.1328ef77.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow-black.png
// module id = 60
// module chunks = 0